export default String.raw`
<!DOCTYPE html>
<html lang="{{ page.Language }}">
<head>
    <meta charset="utf-8">
    <script>
        window.dataLayer = window.dataLayer || [];

        {% if config.GA4Head or config.GTMHead -%}
            if (typeof gtag == 'undefined') {
                function gtag(){window.dataLayer.push(arguments);}
            }
            gtag("consent", "default", {
                ad_storage: "denied",
                analytics_storage: "denied",
                ad_user_data: "denied",
                ad_personalization: "denied",
            });
            gtag("set", "url_passthrough", true);
        {% endif -%}

        {% if cart.OrderStep != 'ThankYou' -%}
            window.dataLayer = {{ page.GtmDL }};
            {% if page.Ga4DL != '[]' -%}
                window.dataLayer = {{ page.Ga4DL }};
                
                if (typeof gtag == 'undefined') {
                    function gtag(){window.dataLayer.push(arguments);}
                }
                (function(){
                    var i,dl={{ page.Ga4DL }};
                    for(i in dl) gtag(dl[i].eventType, dl[i].event, dl[i].data);
                })();
            {% endif -%}
        {% endif -%}
    </script>
    {{ config.GTMHead }}
	{{ config.GA4Head }}
    <link rel="preconnect" href="https://code.jquery.com" crossorigin>
    <link rel="preconnect" href="https://static.comarchesklep.pl" crossorigin>
    <link rel="preconnect" href="https://fonts.googleapis.com" crossorigin>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <base href="{{ page.BaseHref }}">
    {% if page.CanonicalLink != null -%}
        <link rel="canonical" href="{{ page.CanonicalLink }}">
    {% endif -%}

    {% if page.CanonicalLink contains 'https' -%}
        {% assign protocol = 'https:' -%}
    {% else -%}
        {% assign protocol = 'http:' -%}
    {% endif -%}
    {% capture shopBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}

    {% comment %} hreflang: default language has no url prefix, other languages have "code/" prefix {% endcomment %}
    {% assign currentLanguageSuffix = '/' | Append: page.Language | Append: '/$' -%}
    {% assign defaultLanguage = config.DefaultLanguage.Language -%}
    {% if defaultLanguage == null or defaultLanguage == '' -%}
        {% comment %} fallback for backend without config.DefaultLanguage: only current language page without prefix or two languages shop are certain {% endcomment %}
        {% assign defaultLanguage = '' -%}
        {% assign rootHref = page.BaseHref | Replace: currentLanguageSuffix, '/' -%}
        {% if rootHref == page.BaseHref -%}
            {% assign defaultLanguage = page.Language -%}
        {% else -%}
            {% assign languagesSize = config.Languages | Size -%}
            {% if languagesSize == 2 -%}
                {% for language in config.Languages -%}
                    {% if language.Language != page.Language -%}
                        {% assign defaultLanguage = language.Language -%}
                    {% endif -%}
                {% endfor -%}
            {% endif -%}
        {% endif -%}
    {% endif -%}
    {% if page.Language == defaultLanguage -%}
        {% assign rootHref = page.BaseHref -%}
    {% else -%}
        {% assign rootHref = page.BaseHref | Replace: currentLanguageSuffix, '/' -%}
    {% endif -%}

    {% assign languageRedirectUrls = '' -%}
    {% if page.CanonicalLink != null and page.AlternateUrls -%}
        {% for alternateUrl in page.AlternateUrls -%}
            {% if alternateUrl.Url contains '//' -%}
                {% assign alternateHref = alternateUrl.Url -%}
            {% else -%}
                {% assign alternateHref = alternateUrl.Url | Replace: '^\./', '' -%}
                {% if alternateUrl.LangCode != defaultLanguage -%}
                    {% assign alternateHref = alternateUrl.LangCode | Append: '/' | Append: alternateHref -%}
                {% endif -%}
                {% assign alternateHref = protocol | Append: rootHref | Append: alternateHref -%}
            {% endif -%}
            <link rel="alternate" href="{{ alternateHref }}" hreflang="{{ alternateUrl.LangCode }}">
            {% capture languageRedirectUrls -%}{{ languageRedirectUrls }}'{{ alternateUrl.LangCode }}': '{{ alternateHref }}',{% endcapture -%}
        {% endfor -%}
    {% elseif page.CanonicalLink != null -%}
        {% assign domainBase = config.Url | Split: '//' | Last -%}
        {% assign pathParts = page.CanonicalLink | Split: page.BaseHref -%}
        {% assign pathPartsSize = pathParts | Size -%}

        {% for language in config.Languages -%}
            {% assign alternateUrl = pathParts | First -%}
            {% assign alternateUrl = alternateUrl | Plus: '//' | Plus: domainBase -%}
            {% if language.Language != defaultLanguage -%}
                {% assign alternateUrl = alternateUrl | Plus: language.Language | Plus: '/' -%}
            {% endif -%}
            {% if pathPartsSize > 1 -%}
                {% assign linkWithoutBase = pathParts | Last -%}
                {% assign alternateUrl = alternateUrl | Plus: linkWithoutBase -%}
            {% endif -%}
            <link rel="alternate" href="{{ alternateUrl }}" hreflang="{{language.Language}}">
        {% endfor -%}
    {% endif -%}
    {% if page.PageId == config.DefinedPages.BlogDetails.Id and languageRedirectUrls != '' -%}
    <script>
        const __languageRedirectUrls = { {{ languageRedirectUrls }} };
    </script>
    {% endif -%}

    <script>
        function windowOnloadAdd(fcn) {
            if (typeof window.onload == 'function') {
                if (!window.onloadFcnArray) {
                    window.onloadFcnArray = [];    
                }
                window.onloadFcnArray.push(fcn);
                window.onload = function() {
                    for (var i = 0; i < window.onloadFcnArray.length; i++) {
                        window.onloadFcnArray[i]();
                    }
                }
            } else {
                window.onloadFcnArray = [fcn];
                window.onload = fcn;
            }
        }

        const cookies = document.cookie.split("; ");
        let cookieSettingsValue;
        if(typeof gtag != 'undefined') {
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].split("=");
                if (cookie[0] === "cookieSettings") {
                    cookieSettingsValue = decodeURIComponent(cookie[1]).split(',');
                }
            }
            if (cookieSettingsValue) {
                if (cookieSettingsValue.length == 1) {
                    gtag("consent", "update", {
                        ad_storage: cookieSettingsValue[0],
                        analytics_storage: cookieSettingsValue[0],
                        ad_user_data: cookieSettingsValue[0],
                        ad_personalization: cookieSettingsValue[0],
                    });
                } else {
                    const consentObj = {
                        ad_storage: "denied",
                        analytics_storage: "denied",
                        ad_user_data: "denied",
                        ad_personalization: "denied",
                    };
                    if (cookieSettingsValue[2] != 'denied') {
                        consentObj['ad_storage'] = "granted";
                        consentObj['ad_user_data'] = "granted";
                        consentObj['ad_personalization'] = "granted";
                    }
                    consentObj['analytics_storage'] = cookieSettingsValue[0];
                    gtag("consent", "update", consentObj);
                }
            }
        }
    </script>

    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1">
    <meta name="theme-color" content="{{settings.primaryColor}}">
    {% block preloadStylesheetIncludes -%}
    {% endblock -%}
    <link rel="preload" href="https://static.comarchesklep.pl/files/js/swiper-11/swiper-bundle.min.css" integrity="sha384-qb3jc85aEQG16jURfFVIetUIc5p6W1uhHNcv5zewh8m3n+IWOHb41WO/3N9Or5Zv" as="style" crossorigin="anonymous">
    <link rel="preload" href="https://code.jquery.com/jquery-3.7.1.min.js" 
        integrity="sha384-1H217gwSVyLSIfaLxHbE7dRb3v4mYCKbpQvzx0cegeju1MVsGrX5xXxAvs/HgeFs" as="script" 
        crossorigin="anonymous">
    <link rel="preload" href="https://static.comarchesklep.pl/files/js/swiper-11/swiper-bundle.min.js" as="script"
        integrity="sha384-MAGmzBVTmeQTSSONI7W9+cXWkt8l4on2ywlU/RB2JrQdD0x275DQ82KA5b+FsXJ2"
        crossorigin="anonymous">
    {% block preloadLayoutJsBlock -%}
    {% endblock -%}
    <link href="css/img/img-placeholder.jpg" as="image">
    {% if page.PageId == config.DefinedPages.ProductList.Id and products.HeaderData.ImageId == 0 -%}
  		<meta property="og:image" content="{{products.HeaderData.Image.ExternalUrl|H}}">
    {% elseif page.PageId == config.DefinedPages.ProductList.Id and products.HeaderData.ImageId > 0 -%}
  		<meta property="og:image" content="{{ shopBase }}img/{{products.HeaderData.ImageId}}/category.jpg">
  	{% elseif page.PageId == config.DefinedPages.ProductDetails.Id -%}
        {% if product-presentation.Product.Image.Id > 0 and product-presentation.Product.Image.Link != null -%}
  		    <meta property="og:image" content="{{ shopBase }}img/{{product-presentation.Product.Image.Id}}/{{product-presentation.Product.Image.Link}}">
        {% elsif product-presentation.Product.Image.ExternalUrl -%}
            <meta property="og:image" content="{{product-presentation.Product.Image.ExternalUrl}}">
        {% else -%}
            <meta property="og:image" content="{{ shopBase }}css/img/img-placeholder.jpg">
        {% endif -%}
        <meta property="og:image:width" content="200">
        <meta property="og:image:height" content="200">
		<!-- Facebook Pixel Product Info -->
        <meta property="og:type" content="product">
        <meta property="og:title" content="{{product-presentation.Product.NameNoHtml | H}}">
        {% if product-details.Product.ShortDescription != '' -%}
            <meta property="og:description" content="{{product-presentation.Product.ShortDescription | H}}">
        {% else -%}
            <meta property="og:description" content="{{product-presentation.Product.NameNoHtml | H}}">
        {% endif -%}
        <meta property="og:url" content="{{ shopBase }}{{product-presentation.Product.Url}}">
        <meta property="product:brand" content="{{product-presentation.Product.Brand.Name}}">
        {% assign availability = product-presentation.Product.Availability.Status -%}
        {% case availability -%}
            {% when 0 -%}
                {% assign availability = "available for order" -%}
            {% when 1 -%}
                {% assign availability = "in stock" -%}
            {% when 3 -%}
                {% assign availability = "out of stock" -%}
            {% else -%}
                {% assign availability = "in stock" -%}
        {% endcase -%}
        <meta property="product:availability" content="{{availability}}">
        <meta property="product:price:amount" content="{{product-presentation.Product.Price | ToString | Replace: config.DecimalSeparator, '.'}}">
        <meta property="product:price:currency" content="{{customer.Currency}}">
        <meta property="product:retailer_item_id" content="{{product-presentation.Product.Id}}">
        <meta property="product:item_group_id" content="{{product-presentation.Product.GIDNumber}}">
        <meta property="product:link" content="{{ shopBase }}{{product-presentation.Product.Url}}">
        {% if page.MetaDescription != '' -%}
            <meta name="description" content="{{ page.MetaDescription | H }}">
            <meta property="og:description" content="{{ page.MetaDescription | H }}">
        {% else -%}
            <meta name="description" content="{{config.Shop.Name}}">
            <meta property="og:description" content="{{config.Shop.Name}}">
        {% endif -%}
        <!-- Facebook Pixel Product Info End -->

    {% elseif page.PageId == config.DefinedPages.BlogDetails.Id -%}
        <meta property="description" content="{{blog.PostDetails.Heading}}">
        <meta property="og:description" content="{{blog.PostDetails.Heading}}">
        <meta property="og:type" content="article">
        <meta property="og:title" content="{{blog.PostDetails.Heading}}">
        <meta property="og:url" content="{{ shopBase }}{{blog.PostDetails.Url}}">
        {% if blog.PostDetails.ImageUrl != null -%}
            <meta property="og:image" content="{% if blog.PostDetails.ImageUrl contains '//' -%}{{blog.PostDetails.ImageUrl}}{% else -%}{{ shopBase }}{{blog.PostDetails.ImageUrl | Replace: '^[./]+', ''}}{% endif -%}">
        {% else -%}
            <meta property="og:image" content="{{ shopBase }}css/img/img-placeholder.jpg">
        {% endif -%}
    {% endif -%}

    {% if page.PageId == config.DefinedPages.ProductList.Id -%}
        {% if products.HeaderData.MetaDescription != '' -%}
            <meta name="description" content="{{ products.HeaderData.MetaDescription | H }}">
            <meta property="og:description" content="{{ products.HeaderData.MetaDescription | H }}">
        {% endif -%}

        {% if products.HeaderData.MetaKeywords != '' -%}
            <meta name="keywords" content="{{ products.HeaderData.MetaKeywords | H }}">
        {% endif -%}
    {% endif -%}

    {% if page.PageId == config.DefinedPages.BlogDetails.Id -%}
        <meta property="og:image:width" content="200">
        <meta property="og:image:height" content="200">
    {% elsif page.PageId == config.DefinedPages.ProductDetails.Id -%}
    {% else -%}
  	    <meta property="og:image:width" content="50">
        <meta property="og:image:height" content="50">
        {% if page.MetaDescription != '' -%}
            <meta name="description" content="{{ page.MetaDescription | H }}">
            <meta property="og:description" content="{{ page.MetaDescription | H }}" >
        {% else -%}
            <meta name="description" content="{{config.Shop.Name}}">
            <meta property="og:description" content="{{config.Shop.Name}}">
        {% endif -%}
    {% endif -%}

    {% if page.PageId == config.DefinedPages.Terms.Id or page.PageId == config.DefinedPages.Privacy.Id or page.PageId == config.DefinedPages.Login.Id or page.PageId == config.DefinedPages.Registration.Id or page.PageId == config.DefinedPages.CustomerProfile.Id or page.PageId == config.DefinedPages.PasswordReminder.Id or page.PageId == config.DefinedPages.AdvancedSearch.Id or products.Search != null -%}
        {% assign robotsContent = 'noindex,nofollow' -%}
    {% else -%}
        {% assign robotsContent = 'index,follow,all' -%}
    {% endif -%}
    <meta name="robots" content="{{robotsContent}}">  
    {% if page.MetaKeywords != '' -%}
        <meta name="keywords" content="{{ page.MetaKeywords | H }}">
    {% endif -%}
    {% if page.LinkPrev != null -%}
        <link rel="prev" href="{{ page.LinkPrev }}">
    {% endif -%}
    {% if page.LinkNext != null -%}
        <link rel="next" href="{{ page.LinkNext }}">
    {% endif -%}
    
    {% if page.PageId == config.DefinedPages.ProductList.Id and products.HeaderData.MetaTitle != '' -%}
        <title>{{ products.HeaderData.MetaTitle | H }}</title>
    {% else -%}
        <title>{{ page.MetaTitle | H }}</title>
    {% endif -%}

    {% assign pageLanguageShort = page.Language | Upcase -%}
	{% assign settingsVariableName = 'grapicalVariantsPresentationColors' | Append: pageLanguageShort -%}
	{% assign grapicalVariantsPresentationColorsData = settings[settingsVariableName] -%}

    <link rel="icon" type="image/png" href="{{ page.BaseHref }}favicon.ico">
    <link rel="apple-touch-icon" href="{{ page.BaseHref }}icon_192.png">
    <link rel="manifest" href="js/manifest.json">
    {% block stylesheetIncludes -%}
    {% endblock -%}
    <link rel="stylesheet" href="https://static.comarchesklep.pl/files/js/swiper-11/swiper-bundle.min.css" integrity="sha384-qb3jc85aEQG16jURfFVIetUIc5p6W1uhHNcv5zewh8m3n+IWOHb41WO/3N9Or5Zv" crossorigin="anonymous">
    {% block fontIncludeBlock -%}
    {% endblock -%} 
    {% if config.AuthenticatedOnly  -%}
        <link rel="prerender" href="{{page.BaseHref}}{{config.DefinedPages.Login.Url}}">
    {% elseif page.PageId == config.DefinedPages.Login.Id or page.PageId == config.DefinedPages.Registration.Id or cart.OrderStep == 'ThankYou' -%}
        <link rel="prerender" href="{{ page.BaseHref }}">
    {% endif -%}
    <script src="https://code.jquery.com/jquery-3.7.1.min.js" integrity="sha384-1H217gwSVyLSIfaLxHbE7dRb3v4mYCKbpQvzx0cegeju1MVsGrX5xXxAvs/HgeFs" crossorigin="anonymous"></script>
    {% if config.External.Google.ClientID != '' and config.External.Google -%}
        <script src="https://accounts.google.com/gsi/client" async defer></script>
    {% endif -%}
    <script>
        __CPLink = "{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}";
        __CartLink = "{{ page.BaseHref }}{{config.DefinedPages.Order.Url}}";
        __ComparerLink = "{{ page.BaseHref }}{{config.DefinedPages.ProductComparisonTool.Url}}";
        __CSRF=(function(z){return atob(z);})('{{page.CSRF|Base64}}'); __decSep='{{ config.DecimalSeparator }}'; __decThoSep = '{{config.DecimalThousandsSeparators}}'; __lng='{{ page.Language }}'; __lngId='{{ page.LanguageId }}'; __gap = '{{ settings.googleMapsKey }}'; __aatc='{{ settings.afterAddingToCart }}'; __redirectInfo = "{{ translations.RedirectInfo }}."; __decUnits = '{{config.Products.DecimalUnits}}'; __decimalPlacesPrice = Number('{{config.DecimalPlacesPrice}}') || 2; __curr = '{{ customer.CurrencyExt }}'; __currCode = '{{ customer.CurrencyExt.Code }}'; __fbId = '{{ config.External.Facebook.AppID }}'; __googleID = '{{ config.External.Google.ClientID }}'; __productIsInCart = '{{settings.productIsInCart}}'; __popupBannerDaysDiff = '{{settings.popupBannerDays}}'; __filterOption = '{{settings.filterOption}}'; __productComparer = '{{config.Products.ProductComparer}}'; __productComparerSize = '{{customer.ComparisonToolItems | Size}}';__iconStyle = "{{settings.iconStyle}}"; __userAuthenticated = '{{usr.Authenticated}}'; __isB2B = '{{config.B2B}}'; __Enterprise = '{{config.ENTERPRISE}}';__graphicalVariantsPresentation = '{{settings.grapicalVariantsPresentation}}';__pageLanguageShort = '{{pageLanguageShort}}';__settingsVariableName = 'grapicalVariantsPresentationColors' + __pageLanguageShort;__grapicalVariantsPresentationColorsData = '{{settings[settingsVariableName]}}';__primaryPageBg = '{{settings.primaryPageBgColor}}'; __subtotalPrices = '{{customer.Cart.SubtotalPrices}}'; __recommendedAIInCart = '{{settings.recommendedAIInCart}}'; __AIEnabled = '{{config.Products.AIEnabled}}'; __lqTS = '{{lqTS}}'; __checkAvailabilityInShopPresentation = '{{settings.checkAvailabilityInShopPresentation}}';
        __cartId='{{settings.cartId}}';
        __translations = {
            confirmDeliveryAddress: "{{ translations.ConfirmDeliveryAddress | H }}",
            confirmInvoiceAddress: "{{ translations.ConfirmInvoiceAddress | H }}",
            confirmAll: "{{ translations.ConfirmAll | H }}",
            confirmed: "{{ translations.Confirmed | H }}",
            executed: "{{ translations.Executed | H }}",
            canceled: "{{ translations.Canceled | H }}",
            ProductOrdered: "{{ translations.ProductOrdered | H }}",
            DeliveryNotAccepted: "{{ translations.DeliveryNotAccepted | H }}",
            DeliveryAccepted: "{{ translations.DeliveryAccepted | H }}",
            Unknown: "{{ translations.Unknown | H }}",
            chooseCollectionPoint: "{{ translations.ChooseCollectionPoint | H }}",
            fillRequiredAttributes: "{{ translations.FillRequiredAttributes | H }}",
            showDetails: "{{ translations.ShowDetails | H }}",
            hideDetails: "{{ translations.HideDetails | H }}",
            yourWishListIsEmpty: "{{ translations.YourWishListIsEmpty | H }}",
            AddedToWishList: "{{ translations.AddedToWishList | H }}",
            AddedToCart: "{{ translations.AddedToCart | H }}",
            AddedToInquiry: "{{ translations.AddedToInquiry | H }}",
            ProductsAddedToInquiry: "{{ translations.ProductsAddedToInquiry | H }}",
            AddedToWishList: "{{ translations.AddedToWishList | H }}",
            pointsProduct: "{{ translations.PointsProduct | H }}",
            recalculateOrder: "{{ translations.RecalculateOrder | H }}",
            stockLvlExceeded: "{{ translations.StockLvlExceeded | H }}",
            fillQuantityOfChoosenProducts: "{{ translations.FillQuantityOfChoosenProducts | H }}",
            BrowserNotSupported: "{{ translations.BrowserNotSupported | H }}",
            UseOtherBrowser: "{{ translations.UseOtherBrowser | H }}",
            ChooseCollectionPoint: "{{ translations.ChooseCollectionPoint | H }}",
            ChooseInpostMachine: "{{ translations.ChooseInpostMachine | H }}",
            ImportErrorOccured: "{{ translations.ImportErrorOccured | H }}",
            NotImportedProducts: "{{ translations.NotImportedProducts | H }}",
            NotImportedAnyProducts: "{{ translations.NotImportedAnyProducts | H }}",
            NotAddedProducts: "{{ translations.NotAddedProducts | H }}",
            NotCopiedProducts: "{{ translations.NotCopiedProducts | H }}",
            NotAddedToWishlist: "{{ translations.NotAddedToWishlist | H }}",
            NotAddedToInquiry: "{{ translations.NotAddedToInquiry | H }}",
            Invoice: "{{ translations.Invoice | H }}",
            ChoosePaymentMethod: "{{ translations.ChoosePaymentMethod | H }}",
            AttachementsNotAdded: "{{ translations.AttachementsNotAdded | H }}",
            OrderErrorMessage: "{{ translations.OrderErrorMessage | H }}",
			NeedToConnectToFb: "{{ translations.NeedToConnectToFb | H }}",
            CantLoginWithFb: "{{ translations.CantLoginWithFb | H }}",
            FailedDisconnectFromFb: "{{ translations.FailedDisconnectFromFb | H }}",
            FailedConnectToFb: "{{ translations.FailedConnectToFb | H }}",
			CantLoginWithGoogle: "{{ translations.CantLoginWithGoogle | H }}",
            FailedDisconnectFromGoogle: "{{ translations.FailedDisconnectFromGoogle | H }}",
            FailedConnectToGoogle: "{{ translations.FailedConnectToGoogle | H }}",
			CreditLimitStatus_2: "{{ translations.CreditLimitStatus_2 | H }}",
            AfterCopyLinkMessage: "{{ translations.AfterCopyLinkMessage | H }}",
            Price_Omnibus: "{{ translations.Price_Omnibus}}",
			productIsInCart: "{{translations.productIsInCart}}",
            PriceFrom: "{{translations.PriceFrom}}",
            PriceTo: "{{translations.PriceTo}}",
            ResetFilters: "{{translations.ResetFilters}}",
            ProductNotFound: "{{translations.ProductNotFound}}",
            PasswordRecovery: "{{translations.ChangePasswordLinkSent}}",
            BackToLogin: "{{ translations.BackToLogin }}",
            LinkSent: "{{ translations.LinkSent}}",
            ToCategoriesList: "{{ translations.ToCategoriesList }}",
            Search: "{{translations.Search}}",
            MessageError:"{{translations.MessageError}}",
            MessageSuccess:"{{translations.MessageSuccess}}",
            MessageWarning:"{{translations.MessageWarning}}",
            MessageInfo:"{{translations.MessageInfo}}",
            ClearAllFilters: "{{translations.ClearAllFilters}}",
            Quantity: "{{translations.Quantity}}",
            NewsLetter_Err1: "{{ translations.NewsLetter_Err1 }}",
            NewsLetter_Err2: "{{ translations.NewsLetter_Err2 }}",
            Compare: "{{ translations.Compare }}",
            Delete: "{{ translations.Delete }}",
            Lookbook_Add_All_Cart: "{{ translations.Lookbook_Add_All_Cart }}",
            EmptySearch: "{{ translations.EmptySearch }}",
            BadPrice: "{{ translations.BadPrice }}",
            netto: "{{ translations.Netto | Downcase }}",
            brutto: "{{ translations.Brutto | Downcase }}",
            FunctionUnavailable: "{{ translations.FunctionUnavailable | H }}",
            LackOfPhone: "{{ translations.LackOfPhone }}",
            Close: "{{ translations.Close }}",
            AfterCopyMessage: "{{ translations.AfterCopyMessage | H }}",
            ChoosePaymentChannel: "{{ translations.ChoosePaymentChannel }}",
            PrevSlide: "{{ translations.PrevSlide }}",
            NextSlide: "{{ translations.NextSlide }}",
            DeleteFromCompare: "{{ translations.DeleteFromCompare }}",
            SuccessfullyDeletedFromComparison: "{{ translations.SuccessfullyDeletedFromComparison }}",
            ShowMore: "{{ translations.ShowMore }}",
            ShowLess: "{{ translations.ShowLess }}",
            Available: "{{ translations.Available | H }}",
            NotAvailable: "{{ translations.NotAvailable | H }}",
            Com_Deposit: "{{ translations.Com_Deposit | H}}",
            WithCode: "{{ translations.WithCode | H}}",
            ValidUntil: "{{ translations.ValidUntil | H}}",
            Until: "{{ translations.Until | H}}",
            FindOutMore: "{{ translations.FindOutMore | H}}",
            ProductOnSaleA: "{{ translations.ProductOnSaleA | H }}",
            ProductOnSaleB: "{{ translations.ProductOnSaleB | H }}",
            GroupDiscount: "{{ translations.GroupDiscount | H}}",
            ShowDiscounts: "{{ translations.ShowDiscounts | H }}",
            CouponCodeCopied: "{{ translations.CouponCodeCopied | H}}",
            ShowMoreDiscounts: "{{ translations.ShowMoreDiscounts | H}}",
            noAvailableCoupons: "{{ translations.noAvailableCoupons | H}}",
            errorLoadingCoupons: "{{ translations.Error | H }}",
            learnMoreClicked: "{{ translations.FindOutMore | H }}",
            validityPrefix: "{{ translations.ValidUntil | H }} ",
            timeSeparator: "{{ translations.timeSeparator | H }}",
            productName: "{{ translations.Product | H }}",
            productCode: "{{ translations.ProductCode | H }}",
            discountPrice: "{{ translations.DiscountPrice | H }}",
            freeDelivery: "{{ translations.FreeDelivery | H }}",
            deliveryDiscount: "{{ translations.DeliveryDiscount | H }}",
            couponName: "{{ translations.Coupon | H }}",
            noImageMessage: "{{ translations.NoImageAvailable | H }}"
        };
            __Colors = {
		    Success: "{{settings.successColor}}",
		    Warning: "{{settings.warningColor}}",
		    Error: "{{settings.errorColor}}"
	    };
    </script>
	{% if config.External.Google.ClientID != '' and config.External.Google -%}
        <script src="js/google-login.js" defer></script>
    {% endif -%}    
    {% if config.B2B and page.PageId != config.DefinedPages.Order.Id and settings.inquiries == 'yes' -%}
        <script>
            function getCookie(cname) {
                const name = cname + "=";
                const ca = document.cookie.split(';');
                for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
                }
                return -1;
            }

            function setCookie(cname, cvalue, exdays) {
                const date = new Date();
                date.setTime(date.getTime() + (exdays*24*60*60*1000));
                const expires = "expires="+date.toUTCString();
                document.cookie = cname + "=" + cvalue + "; " + expires + "; SameSite=Lax; path=/";
            }

            setCookie('lastCartId', {{customer.Cart.Id}})

            const activeInquiryId = getCookie('activeInquiryId');
            let activeCartId = getCookie('lastCartId');
            let savedCartExists = true;

            {% assign cartsSize = customer.Carts | Size -%}
            {% if cartsSize > 0 and customer.Cart.Id != -1 -%}
                savedCartExists = false;
                {% if cartsSize > 1 -%}
                    const carts = {% for oneOfCart in customer.Carts -%}'{{oneOfCart.Id}}'{% if forloop.index != cartsSize -%}+'|'+{% endif -%}{% endfor -%};
                    const cartsArr = carts.split('|');
                    for(let i=0; i<cartsArr.length; i++){
                        if(cartsArr[i] == activeCartId){
                            savedCartExists = true;
                        }
                    }
                {% else -%}
                    if({{customer.Carts[0].Id}} == activeCartId){
                        savedCartExists = true
                    }
                {% endif -%}
                
                if(!savedCartExists){
                    setCookie('lastCartId', {{customer.Cart.Id}})
                }
            {% endif -%}

            if((activeCartId != {{customer.Cart.Id}} && savedCartExists) || {{customer.Cart.Inquiry}} || (activeCartId == activeInquiryId && activeCartId != -1)){
                if(activeCartId == activeInquiryId && activeCartId != -1){
                    activeCartId = -1;
                }
                setCookie('lastCartId', activeCartId);
                if($('.during-ajax-modal-js').length == 0){
                    $('body').append('<div class="during-ajax-modal-js during-ajax-modal hidden-js"><div class="loader big"></div></div>');
                }
                $.post('', {__action: 'Cart/Change', id: activeCartId, __csrf: __CSRF}, function() {
                    $.post('', {__action: 'Inquiry/Set', inquiry: false, __csrf: __CSRF}, function() {
                        window.location.reload();
                    });
                });
            }
        </script>
    {% endif -%}
    {% if settings.autoLanguage == 'yes' %}
        {% assign languagesSize = config.Languages | Size -%}
        {% if languagesSize > 1 -%}
            <script>
                if(sessionStorage.getItem('autoLanguage') != 'true' && (!(navigator.userAgent.includes('Lighthouse')))){
                    sessionStorage.setItem('autoLanguage', 'true');
                    var browserLanguage = navigator.language.split('-')[0];
                    var currentLanguage = '{{page.Language}}';
                    if(currentLanguage != browserLanguage){
                        var languages = [
                            {% for language in config.Languages -%}
                                {
                                    short: '{{language.Language}}',
                                    id: '{{language.Id}}'
                                }{% if forloop.index != languagesSize -%},{% endif -%}
                            {% endfor -%}
                        ];
                        for(i=0; i<languages.length; i++){
                            if(languages[i].short == browserLanguage){
                                var data = {
                                    __csrf: __CSRF,
                                    __action: 'Customer/LanguageChange',
                                    languageId: Number(languages[i].id)
                                };
                                $.post(null, data, function(result) {
                                    window.location.assign((typeof __languageRedirectUrls !== 'undefined' && __languageRedirectUrls[browserLanguage]) || result.action.Redirect302);
                                });
                            }
                        }
                    }
                }
            </script>
        {% endif -%}
    {% endif %}
    {% include 'edrone/head.html' %}
    {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
        {% include 'partials/product/gs1-smart-search.html' %}
    {% endif -%}
    {{ globalSettings.SnapchatPixel.Script }}
    {% if cart.OrderStep != 'ThankYou' -%}
        <script>
			if(typeof fbq !== 'undefined'){
				var fbDL={{ page.FbDL }};
				!function(){var e;while(e=fbDL.pop())fbq.push(e);}();
			}
        </script>
    {% endif -%}
    {% if page.PageId == config.DefinedPages.Home.Id -%}
        <script>
            var url = $('meta[property="og:image"]').attr('content');
            if (url) {
                var image = new Image();
                image.src = url;
                image.onload = function() {
                    if (image.naturalWidth < 200 || image.naturalHeight < 200) {
                        $('meta[property="og:image"]').attr('content', '{{ shopBase }}usr/miniature.png');
                    }
                }
            } 
        </script>
    {% endif -%}
    <script>
		if(typeof fbq !== 'undefined'){
			if(cookieSettingsValue != undefined && (cookieSettingsValue == 'denied' || cookieSettingsValue[2] == 'denied')){
				window.fbq = function() {
				};
				window.fbq();
			}
		}
    </script>
{% if settings.logo_trusted_shop == 'logo_trusted_shop-yes' %}

<script async 
data-desktop-y-offset="{{settings.logo_trusted_desktopYOffset | ToInt | Plus: 30 | ToString}}" 
data-mobile-y-offset="{{settings.logo_trusted_mobileYOffset | ToInt | Plus: 70 | ToString}}" 
data-desktop-disable-reviews="{{settings.logo_trusted_disableReviews}}" 
data-desktop-enable-custom="false" 
data-desktop-position="{{settings.logo_trusted_desktopPosition}}" 
data-desktop-custom-width="156" 
data-desktop-enable-fadeout="{{settings.logo_trusted_desktop-enable-fadeout}}" 
data-disable-mobile="{{settings.logo_trusted_data-disable-mobile}}" 
data-disable-trustbadge="false" 
data-mobile-custom-width="156" 
data-mobile-disable-reviews="{{settings.logo_trusted_disableReviews}}" 
data-mobile-enable-custom="false" 
data-mobile-position="{{settings.logo_trusted_mobilePosition}}" 
data-mobile-enable-topbar="{{settings.logo_trusted_mobile-enable-topbar}}" 
data-mobile-enable-fadeout="{{settings.logo_trusted_mobile-enable-fadeout}}"
data-color-scheme="{{settings.logo_trusted_colorScheme}}" 
charset="UTF-8" 
src="{{settings.logo_trusted_shopUrlID}}"> 
</script>





<script>
    let mainPage = {{config.DefinedPages.Home.Id}};
    let cartPage = {{config.DefinedPages.Order.Id}};
    let productListPage = {{config.DefinedPages.ProductList.Id}};
    let productDetailsPage = {{config.DefinedPages.ProductDetails.Id}};
    let currentPage = {{page.PageId}}
    let hideMainPage =  '{{settings.logo_trusted_MainPage}}' == 'showMainPage'? false : true;
    let hideProductList =  '{{settings.logo_trusted_ProductsList}}' == 'showProductsList'? false : true;
    let hideProductDetails =  '{{settings.logo_trusted_ProductDetails}}' == 'showProductDetails'? false : true;
    let hideCart =  '{{settings.logo_trusted_Cart}}' == 'showCart'? false : true;
    let trustBadgeValue = false;
    if(currentPage == mainPage && hideMainPage){
        trustBadgeValue = true
    }else if(currentPage == cartPage  && hideCart){

        trustBadgeValue = true
    }else if(currentPage == productListPage && hideProductList){


        trustBadgeValue = true
    }else if(currentPage == productDetailsPage && hideProductDetails){

        trustBadgeValue = true
    }
    else{
        trustBadgeValue = false
    }
    let scriptElement = document.querySelector('script[data-disable-trustbadge]');
    
    if (scriptElement) {
        scriptElement.setAttribute('data-disable-trustbadge', trustBadgeValue);
    }
</script>
{% endif -%}

<style>
    [id^="trustbadge-container"] {
        z-index: 998 !important; 
    }
</style>

{% if config.Ceneo4Head != null -%}
    {{config.Ceneo4Head}}
{% endif -%}

</head>

<body>
    {{ config.GTM }}
    {% if page.QueryString contains 'offline' -%}
        {% include 'static-elements/offline/offline.html' -%}
    {% elseif settings.technicalBreak == "yes" -%}
        {% include 'partials/common/header/header-top-bar.html' -%}
            <div class="technical-break">
                <div class="content">
                    <img src="{{config.Shop.ImageUrl}}" alt="{{ config.Shop.Name }}" loading="eager" fetchpriority="high">
                    <div class="content__mobile">
                        <img src="css/img/technical-break.png" alt="{{translations.TechnicalBreak}}" loading="eager" fetchpriority="high">
                    </div>
                    <div class="content__info">
                        <div>
                            {{translations.TechnicalBreak}}
                        </div>
                        <div class="description">
                            {{translations.TechnicalBreakInfo}}
                        </div>
                        {% capture phone -%}<a href="tel:{{ config.Shop.Contact.PhoneNo }}">{{ config.Shop.Contact.PhoneNo }}</a>{% endcapture -%}
                        {% capture mail -%}<a href="mailto:{{ config.Shop.Contact.Email }}">{{ config.Shop.Contact.Email }}</a>{% endcapture -%}
                        <div class="description">
                            {{translations.TechnicalBreakContact | Format: phone, mail}}
                        </div>
                    </div>
                </div>
                <div class="technical-break__image">
                    <img src="css/img/technical-break.png" alt="{{translations.TechnicalBreak}}" width="600" height="600" loading="eager" fetchpriority="high">
                </div>
            </div>
            <script src="https://static.comarchesklep.pl/files/js/swiper-11/swiper-bundle.min.js" integrity="sha384-MAGmzBVTmeQTSSONI7W9+cXWkt8l4on2ywlU/RB2JrQdD0x275DQ82KA5b+FsXJ2" crossorigin="anonymous" defer></script>
        {% comment -%}
            Uwaga: Dodatkowa opłata.
            Usunięcie informacji o producencie oprogramowania jest równoznaczne z akceptacją naliczenia opłaty zgodnie z cennikiem Comarch e-Sklep.
            Szczegóły w regulaminie usługi Comarch e-Sklep

            Note: Additional charges.
            Removal of the information about the software provider is tantamount to accepting the calculation of the fee according to Comarch e-Shop price list.
            For details, refer to the terms of use of Comarch e-Shop service.
        {% endcomment -%}
        {% assign year = config.Now | Date : "yyyy" -%}
    {% else -%}
		{{ globalSettings.FbPixel.Script }}
        {{ globalSettings.TiktokPixel.Script }}
        {% if page.TiktokDL and page.TiktokDL != '[]' -%}
            <script>var tiktokDL={{ page.TiktokDL }};</script>
        {% endif -%}
        {% if page.SnapchatDL and page.SnapchatDL != '[]' -%}
            <script>var snapchatDL={{ page.SnapchatDL }};</script>
        {% endif -%}
        <noscript>
            <div class="no-javascript-hidden"></div>
            <div class="no-javascript">{{ translations.NoJS }}</div>
        </noscript>
		{% if config.External.Facebook.AppID != '' and config.External.Facebook %}
            <script src="js/fb-login.js" defer></script>
        {% endif -%}

        {% assign showHeader = true -%}
        {% assign showFooter = true -%}

        {% if page.PageId == config.DefinedPages.Order.Id -%}
            {% if cart.OrderStep == 'CustomerData' or cart.OrderStep == 'Summary' -%}
                {% assign showHeader = false -%}
                {% assign showFooter = false -%}
            {% endif -%}
            {% if cart.OrderStep == "Start" and page.Cookies.cartAuthenticateStep == 'true' and usr.Authenticated == false -%}
                {% assign showHeader = false -%}
                {% assign showFooter = false -%}
            {% endif -%}
        {% endif -%}

        {% if showHeader -%}
            {% block headerBlock -%}
            {% endblock -%}
        {% endif -%}

        <div id="main" class="main-js clear-after page-container">
            <div class="main-content main-content-js">
        
                {% if page.IsHttp404 -%}
                    {% include 'partials/common/page-not-found.html' -%}
                {% else -%}
                    {% block pageContent -%}
                    {% endblock -%}
                {% endif -%}

                {% assign msgCounterP = 0 -%}
                {% for msg in config.Messages -%}
                    {% assign msgCounterP = msgCounterP | Plus: 1 -%}
                    {% if msg.Type == 2 -%}
                        {% include 'partials/common/cookies-message.html', msgCounter: msgCounterP -%}
                    {% endif -%}
                {% endfor -%}
                <div aria-label="{{translations.Cookies}}" role="button" tabindex="0" class="cookie-message-opener cookie-message-opener-js">
                    <svg class="cookie-message-opener-icon">
                        <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#cookie-bite-{{settings.iconStyle}}"></use>
                    </svg>
                </div>
            </div>
        </div>
        {% if showFooter -%}
            {% unless __consents -%}
                {% block footerBlock -%}
                {% endblock -%}
            {% endunless -%}
        {% endif -%}

        <button aria-label="{{ translations.GoToTop }}" class="go-to-top-button go-to-top-button-js">
            <svg>
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
            </svg>
        </button>

        <script src="https://static.comarchesklep.pl/files/js/swiper-11/swiper-bundle.min.js" integrity="sha384-MAGmzBVTmeQTSSONI7W9+cXWkt8l4on2ywlU/RB2JrQdD0x275DQ82KA5b+FsXJ2" crossorigin="anonymous"></script>

        {% if config.External.SalesManago -%}
            <script type="text/javascript">
                if(cookieSettingsValue == undefined || cookieSettingsValue == 'granted' || cookieSettingsValue[0] == 'denied'){

                    var _smid = '{{ config.External.SalesManago.ClientID }}';
                    {% if customer.Authenticated -%}
                    var _smclientid = '{{ customer.Attributes.SalesManagoClientId }}';
                    {% endif -%}
                    (function(w, r, a, sm, s ) {
                        w['SalesmanagoObject'] = r;
                        w[r] = w[r] || function () {( w[r].q = w[r].q || [] ).push(arguments)};
                        sm = document.createElement('script'); sm.type = 'text/javascript'; sm.async = true; sm.src = a;
                        s = document.getElementsByTagName('script')[0];
                        s.parentNode.insertBefore(sm, s);
                        })(window, 'sm', 'https://{{ config.External.SalesManago.Endpoint }}/static/sm.js');
                    }
                </script>
        {% endif -%}

        {% unless __consents -%}
            {% if page.PageId == config.DefinedPages.Order.Id -%}
                <script src="{{ cart.CollectionPointMapUrl }}"></script>
                <script>var _CollectionPointMapUrl = '{{ cart.CollectionPointMapUrl }}';</script>
                <script src="js/collection-points.js?v={{ lqTS }}"></script>
            {% endif -%}
            {% include 'edrone/product-presentation.html' %}
        {% endunless -%}
    {% endif -%}
    {% comment -%} <!-- Generic popups rendered fully by client side --> {% endcomment -%}
    <div class="popup-js"></div>

    {% if settings.afterAddingToCart == 3 -%}
        {% comment -%} <!-- Global after adding to cart popup - hydrated with added products and AI Reccommendations --> {% endcomment -%}
        {% include 'partials/product/after-adding-to-popup.html' with 'cart' -%}
    {% endif -%}

    {% if config.B2B and settings.inquiries == 'yes' -%}
        {% comment -%} <!-- Global after adding to inquiry popup - requires B2B --> {% endcomment -%}
        {% include 'partials/product/after-adding-to-popup.html' with 'inquiry' -%}
    {% endif -%}

    {% comment -%} <!-- Global after adding to wishlist popup --> {% endcomment -%}
    {% include 'partials/product/after-adding-to-popup.html' with 'wishlist' -%}

    {% comment -%} <!-- Global validation failure popup --> {% endcomment -%}
    {% include 'partials/product/validation-popup.html' -%}

    {% comment -%} <!-- Global coupons popup --> {% endcomment -%}
    {% include 'partials/common/coupons-popup.html' -%}

    {% block layoutJsBlock -%}
    {% endblock -%}
    {% if settings.google_translate == 'google_translate-yes' -%}
        <script>
            function googleTranslateElementInit() {
                new google.translate.TranslateElement({pageLanguage: 'pl', layout: google.translate.TranslateElement.InlineLayout.SIMPLE,  includedLanguages: 'en,de,uk,ru,cs,sk,sq,be,bg,hr,da,et,fi,fr,el,ka,es,nl,is,ja,ko,lt,lv,mk,no,pt,ro,sr,sl,sv,tr,it,hu'}, 'google_translate_element');
            }
        </script>
        <script src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>
    {% endif -%}
    {% if order.OrderStep != 'ThankYou' -%}
        <script>
            if(typeof snaptr !== 'undefined'){
                var snapchatDL={{ page.SnapchatDL }}
                for (let i = 0; i < snapchatDL.length; i++) {
                    setTimeout(() => {
                        const e = snapchatDL[i];
                        if (e?.[2]) {
                            e[2].client_dedup_id = e?.[1] + '_' + new Date().getTime();
                        }
                        snaptr(e?.[0], e?.[1], e?.[2]);
                    }, i * 500);
                }
            }

            if(typeof ttq !== 'undefined'){
                for (let i = 0; i < tiktokDL.length; i++) {
                    setTimeout(() => {
                        const e = tiktokDL[i];
                        ttq.track(e?.[0], e?.[1], e?.[2]);
                    }, i * 500);
                }
            }
        </script>
    {% endif -%}
</body>
</html>
`